import E from "../../../../_virtual/isFunction.js";
import { isNumber as T, mathSign as D } from "../util/DataUtils.js";
import { getStringSize as P } from "../util/DOMUtils.js";
import { Global as x } from "../util/Global.js";
import { getNumberIntervalTicks as B, getTickBoundaries as F, isVisible as j, getAngledTickWidth as K } from "../util/TickUtils.js";
import { getEquidistantTicks as N } from "./getEquidistantTicks.js";
function O(r) {
  "@babel/helpers - typeof";
  return O = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, O(r);
}
function z(r, t) {
  var e = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(r);
    t && (o = o.filter(function(c) {
      return Object.getOwnPropertyDescriptor(r, c).enumerable;
    })), e.push.apply(e, o);
  }
  return e;
}
function u(r) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? z(Object(e), !0).forEach(function(o) {
      q(r, o, e[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(e)) : z(Object(e)).forEach(function(o) {
      Object.defineProperty(r, o, Object.getOwnPropertyDescriptor(e, o));
    });
  }
  return r;
}
function q(r, t, e) {
  return t = A(t), t in r ? Object.defineProperty(r, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : r[t] = e, r;
}
function A(r) {
  var t = G(r, "string");
  return O(t) == "symbol" ? t : t + "";
}
function G(r, t) {
  if (O(r) != "object" || !r) return r;
  var e = r[Symbol.toPrimitive];
  if (e !== void 0) {
    var o = e.call(r, t);
    if (O(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(r);
}
function I(r, t, e, o, c) {
  for (var l = (o || []).slice(), f = l.length, m = t.start, i = t.end, y = function(d) {
    var n = l[d], p, S = function() {
      return p === void 0 && (p = e(n, d)), p;
    };
    if (d === f - 1) {
      var s = r * (n.coordinate + r * S() / 2 - i);
      l[d] = n = u(u({}, n), {}, {
        tickCoord: s > 0 ? n.coordinate - s * r : n.coordinate
      });
    } else
      l[d] = n = u(u({}, n), {}, {
        tickCoord: n.coordinate
      });
    var g = j(r, n.tickCoord, S, m, i);
    g && (i = n.tickCoord - r * (S() / 2 + c), l[d] = u(u({}, n), {}, {
      isShow: !0
    }));
  }, a = f - 1; a >= 0; a--)
    y(a);
  return l;
}
function V(r, t, e, o, c, l) {
  var f = (o || []).slice(), m = f.length, i = t.start, y = t.end;
  if (l) {
    var a = o[m - 1], h = e(a, m - 1), d = r * (a.coordinate + r * h / 2 - y);
    f[m - 1] = a = u(u({}, a), {}, {
      tickCoord: d > 0 ? a.coordinate - d * r : a.coordinate
    });
    var n = j(r, a.tickCoord, function() {
      return h;
    }, i, y);
    n && (y = a.tickCoord - r * (h / 2 + c), f[m - 1] = u(u({}, a), {}, {
      isShow: !0
    }));
  }
  for (var p = l ? m - 1 : m, S = function(b) {
    var v = f[b], w, k = function() {
      return w === void 0 && (w = e(v, b)), w;
    };
    if (b === 0) {
      var C = r * (v.coordinate - r * k() / 2 - i);
      f[b] = v = u(u({}, v), {}, {
        tickCoord: C < 0 ? v.coordinate - C * r : v.coordinate
      });
    } else
      f[b] = v = u(u({}, v), {}, {
        tickCoord: v.coordinate
      });
    var _ = j(r, v.tickCoord, k, i, y);
    _ && (i = v.tickCoord + r * (k() / 2 + c), f[b] = u(u({}, v), {}, {
      isShow: !0
    }));
  }, s = 0; s < p; s++)
    S(s);
  return f;
}
function U(r, t, e) {
  var o = r.tick, c = r.ticks, l = r.viewBox, f = r.minTickGap, m = r.orientation, i = r.interval, y = r.tickFormatter, a = r.unit, h = r.angle;
  if (!c || !c.length || !o)
    return [];
  if (T(i) || x.isSsr)
    return B(c, typeof i == "number" && T(i) ? i : 0);
  var d = [], n = m === "top" || m === "bottom" ? "width" : "height", p = a && n === "width" ? P(a, {
    fontSize: t,
    letterSpacing: e
  }) : {
    width: 0,
    height: 0
  }, S = function(v, w) {
    var k = E(y) ? y(v.value, w) : v.value;
    return n === "width" ? K(P(k, {
      fontSize: t,
      letterSpacing: e
    }), p, h) : P(k, {
      fontSize: t,
      letterSpacing: e
    })[n];
  }, s = c.length >= 2 ? D(c[1].coordinate - c[0].coordinate) : 1, g = F(l, s, n);
  return i === "equidistantPreserveStart" ? N(s, g, S, c, f) : (i === "preserveStart" || i === "preserveStartEnd" ? d = V(s, g, S, c, f, i === "preserveStartEnd") : d = I(s, g, S, c, f), d.filter(function(b) {
    return b.isShow;
  }));
}
export {
  U as getTicks
};
